import { render, staticRenderFns } from "./commerce7-start-conversation.vue?vue&type=template&id=d765c3ee&scoped=true&"
import script from "./commerce7-start-conversation.vue?vue&type=script&lang=js&"
export * from "./commerce7-start-conversation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d765c3ee",
  null
  
)

export default component.exports